<template>
	<div>
		<div class="container">
			<Menu :openKey="'6'" :name="'家居服务'"></Menu>
			<div class="content">
				<a-breadcrumb class="nav" :routes="routes">
					<template slot="itemRender" slot-scope="{ route, routes }">
						<span class="active" v-if="routes.indexOf(route) === routes.length - 1">
							{{ route.breadcrumbName }}
						</span>
						<router-link v-else :to="`${basePath}/${route.path}`">
							{{ route.breadcrumbName }}
						</router-link>
					</template>
				</a-breadcrumb>
				<div style="margin-top: 20px">
					<div v-if="isRouter">
						<Article v-for="item in data.records" :key="item.articleId" :data="item" @success="success(item)"></Article>
						<a-row>
							<a-col span="12" offset="6" style="text-align: center; padding: 20px 0">
								<a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext" @showSizeChange="setLimit" :current="data.current" />
							</a-col>
						</a-row>
					</div>
					<router-view style="margin-top: 20px" v-if="!isRouter"></router-view>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import utils from '@/common/utils';
// import Brand from './components/brand.vue';
// import School from './components/school.vue';
import Article from '../components/article.vue';
import Menu from '../components/menu.vue';

export default {
	components: { Article, Menu },
	data() {
		return {
			isRouter: true,
			data: {},
			param: {
				current: 1,
				limit: 10,
				keyword: ''
			},
			basePath: '/index',
			routes: [
				{
					path: 'home',
					breadcrumbName: '首页'
				},
				{
					path: 'furnishings',
					breadcrumbName: '家居服务'
				}
			]
		};
	},
	created() {
		this.$watch('$route', (to, from) => {
			if (to.path) {
				this.isRouter = true;
				if (to.path == '/index/furnishings') {
					this.routes.pop();
				}
			}
		});
	},
	mounted() {
		this.getList();
	},
	methods: {
		getList() {
			utils.showSpin();
			this.http.get('/api/common/home', this.param).then(ret => {
				this.data = ret.data;
				utils.closeSpin();
			});
		},
		//设置每页的显示条数
		setLimit(current, limit) {
			this.param.page = 1;
			this.param.limit = limit;
			this.getList();
		},
		//页码切换
		getNext(page) {
			this.param.page = page;
			this.getList();
		},
		async success(item) {
			await this.$router.push({
				path: '/index/furnishings/detail',
				query: {
					id: item.articleId
				}
			});
			this.isRouter = false;
			this.routes.push({
				path: 'furnishings/detail',
				breadcrumbName: item.title
			});
		}
	}
};
</script>
<style scoped>
.container {
	width: 80%;
	min-width: 598px;
	margin: 0 auto;
	margin-top: 40px;
	display: flex;
}

.brands {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}
.ant-breadcrumb a:hover {
	color: #e96432 !important;
}
.content {
	width: 100%;
	margin-left: 80px;
	height: 40px;
	background: #f7f7f7;
}
.nav {
	margin-top: 10px;
	margin-left: 10px;
	cursor: pointer;
}
.menu-item {
	height: 40px;
	padding: 12px 24px;
	cursor: pointer;
	color: #e96432;
}
.active {
	color: #e96432 !important;
}
.menu-item-group {
	cursor: pointer;
	border-top: 1px solid #d9d9d9;
}
.menu-item-group-title {
	padding: 12px 33px;
	color: #999;
}
.menu-item-group-title:hover {
	color: #e96432;
}
.nav .ant-breadcrumb-link {
	color: #e96432;
}
.ant-breadcrumb {
	color: #e96432;
}
</style>
